export default "__VITE_ASSET__BEj_PK$a__"